import {connect} from 'react-redux';
import {Marker as Component} from './Marker';
import {
  createMarker,
  setMarkerOpen,
  // setMarkerControlVisibility,
  setHeld,
  setHeldObject,
  // showMoveMenu,

  hideAllControls,
  pushInteractions,
  setGelControlVisibility,
  setGelOnShelf,
  setGelInScene,
  setGelInBox,
  setGelHeld,
  setGelInTransilluminator,
  setModal,
  showModal,
} from '@learningblocks/protocol-redux/lib/Actions';


//  const mapStateToProps = (state, ownProps) => {
//    return {
//        aria: ownProps.aria,
//        id: ownProps.id,
//        type: state.gel.gels[ownProps.id-1].type,
//        controlsVisible: state.gel.gels[ownProps.id-1].controlsVisible,
//        inScene: state.gel.gels[ownProps.id-1].inScene,
//        interactions: state.scene.interactions,
//        target: state.scene.lastDrop.lastTarget,
//        interactionProps: {
//          gelBoxes: state.gelBox.gelBoxes,
//        },
//        moveMenuDisplay: state.moveMenu.display,
//    }
// }

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("marker") &&
     state.notebook.protocolSection.scene.apparatus.marker.some(
       marker => marker.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.marker[ownProps.id-1].type,
      open: state.notebook.protocolSection.scene.apparatus.marker[ownProps.id-1].open,
      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      heldObject: state.notebook.protocolSection.scene.heldObject,

      inScene: state.notebook.protocolSection.scene.apparatus.marker[ownProps.id-1].inScene,
      interactions: state.notebook.protocolSection.scene.interactions,
      target: state.notebook.protocolSection.scene.lastDrop.lastTarget,
      interactionProps: {
         gelBoxes: state.notebook.protocolSection.scene.apparatus.gelBoxes,
         transilluminator: state.notebook.protocolSection.scene.apparatus.transilluminator,
       },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {

  return {
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setGelControlVisibility: (data) => {
      dispatch(setGelControlVisibility(data))
    },

    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    },
    
    setMarkerOpen: (data) => {
      dispatch(setMarkerOpen(data))
    },

    setGelOnShelf: (data) => {
      dispatch(setGelOnShelf(data))
    },
    setGelInScene: (data) => {
      dispatch(setGelInScene(data))
    },
    setGelInTransilluminator: (data) => {
      dispatch(setGelInTransilluminator(data))
    },
    setGelInBox: (data) => {
      dispatch(setGelInBox(data))
    },
    createMarker: (data) => {
      dispatch(createMarker(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setGelHeld: (data) => {
      dispatch(setGelHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
  };
}

export const Marker = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
